module.exports = __webpack_public_path__ + "static/img/33.8ae59ab3.jpeg";